// extracted by mini-css-extract-plugin
module.exports = {"root":"email-info-block_root__2La10","text":"email-info-block_text__m69uf","value":"email-info-block_value___4yjo","change_button":"email-info-block_change_button__ucFU_"};